import { defineType, defineField } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  type: "object",
  name: "perk",
  title: "Perk",
  fields: [
    defineField({
      name: "specialPerkType",
      title: "Special Perk Type",
      type: "reference",
      to: [{ type: "specialPerksType" }],
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "image",
      title: "Image",
      type: "imageWithCaption",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "description",
      title: "Description",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    })
  ],
  preview: {
    select: { title: "title" },
    prepare: ({ title }) => ({
      title: multilingualStringPreview(title)
    })
  }
});
